<template>
  <div class="balance" @click="toggleDropdown('balance')">
    <div
      class="balance-label"
      data-id="toggle-balance-header"
      @click="isOpen = !isOpen"
    >
      <div class="balance-label__value">
        <CashboxBalanceItem :value="c_balance.rawBalance" :label="$tc('headerData.balance')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'
import { formatNumberFilter } from '@/util/helpers/vueFilters'
/** Components */
import CashboxBalanceItem from '@/components/Cashbox/Navigation/BalanceItem'

export default {
  name: 'HeaderData',
  components: { CashboxBalanceItem },
  directives: { ClickOutside },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'isUserLoaded']),
    c_balance() {
      return this.isUserLoaded
        ? {
          rawBalance: formatNumberFilter(this.user.balance, { format: 'currency', isShowSymbol: false }),
          balance: formatNumberFilter(this.user.balance,{ format: 'balance' }),
          maxPayout: formatNumberFilter(this.user.max_payout,{ format: 'balance' }),
          bonus: formatNumberFilter(this.user.bonus_balance,{ format: 'balance' }),
          wager: formatNumberFilter(this.user.wager_balance,{ format: 'balance' }),
        }
        : {
          balance: '--',
          maxPayout: '--',
          bonus: '--',
          wager: '--',
        }
    },
  },
  methods: {
    ...mapActions('base', ['toggleDropdown']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
